export default function RightIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 3C8.82 3 3 8.82 3 16C3 23.18 8.82 29 16 29C23.18 29 29 23.18 29 16C29 8.82 23.18 3 16 3ZM21.7067 16.7067C21.8939 16.5192 21.9991 16.265 21.9991 16C21.9991 15.735 21.8939 15.4808 21.7067 15.2933L17.7067 11.2933C17.6151 11.1951 17.5047 11.1163 17.3821 11.0616C17.2594 11.007 17.127 10.9776 16.9927 10.9752C16.8584 10.9728 16.7251 10.9975 16.6005 11.0478C16.476 11.0981 16.3629 11.173 16.268 11.268C16.173 11.3629 16.0981 11.476 16.0478 11.6005C15.9975 11.7251 15.9728 11.8584 15.9752 11.9927C15.9776 12.127 16.007 12.2594 16.0616 12.3821C16.1163 12.5047 16.1951 12.6151 16.2933 12.7067L18.5867 15H11C10.7348 15 10.4804 15.1054 10.2929 15.2929C10.1054 15.4804 10 15.7348 10 16C10 16.2652 10.1054 16.5196 10.2929 16.7071C10.4804 16.8946 10.7348 17 11 17H18.5867L16.2933 19.2933C16.1951 19.3849 16.1163 19.4953 16.0616 19.618C16.007 19.7406 15.9776 19.873 15.9752 20.0073C15.9728 20.1416 15.9975 20.2749 16.0478 20.3995C16.0981 20.524 16.173 20.6371 16.268 20.7321C16.3629 20.827 16.476 20.9019 16.6005 20.9522C16.7251 21.0025 16.8584 21.0272 16.9927 21.0248C17.127 21.0224 17.2594 20.993 17.3821 20.9384C17.5047 20.8837 17.6151 20.8049 17.7067 20.7067L21.7067 16.7067Z"
        fill="currentColor"
      />
    </svg>
  );
}
